import { NutritionRoute } from './NutritionRoutes'
import {
  createBrowserRouter,
  createMemoryRouter,
  type RouteObject,
} from 'react-router-dom'

import { AppRoot } from './AppRoot'
import type { AppServices } from './AppProviders'
import { TodayPage } from '@/features/today/TodayPage'
import { MetricDetailRoute, MetricFormRoute } from './MetricRoutes'
import { SleepDetailRoute, SleepFormRoute } from './SleepRoutes'
import { SettingsRoute } from './SettingsRoutes'
import { WorkoutFormRoute, WorkoutsRoute } from './WorkoutRoutes'

function createRoutes(services: AppServices): RouteObject[] {
  return [
    {
      path: '/',
      element: <AppRoot services={services} />,
      children: [
        { index: true, element: <TodayPage /> },
        { path: 'metrics/:type', element: <MetricDetailRoute /> },
        { path: 'metrics/:type/new', element: <MetricFormRoute /> },
        { path: 'metrics/:type/:id/edit', element: <MetricFormRoute /> },
        { path: 'sleep', element: <SleepDetailRoute /> },
        { path: 'sleep/new', element: <SleepFormRoute /> },
        { path: 'sleep/:id/edit', element: <SleepFormRoute /> },
        { path: 'workouts', element: <WorkoutsRoute /> },
        { path: 'workouts/new', element: <WorkoutFormRoute /> },
        { path: 'workouts/:id/edit', element: <WorkoutFormRoute /> },
        { path: 'nutrition', element: <NutritionRoute /> },
        { path: 'settings', element: <SettingsRoute /> },
      ],
    },
  ]
}

export function createAppRouter(services: AppServices, initialEntries?: string[]) {
  const routes = createRoutes(services)
  return initialEntries === undefined
    ? createBrowserRouter(routes)
    : createMemoryRouter(routes, { initialEntries })
}
